// extracted by mini-css-extract-plugin
export default {"view":"View_view__yCHvi","layerMask":"View_layerMask__Nfa9W","layerMaskPlaceholder":"View_layerMaskPlaceholder__nq3VU","infoText":"View_infoText__AM6Bo"};